import React, { Fragment } from "react";
import PropTypes from "prop-types";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import Table from "../../common/Table";
import { Popup } from 'semantic-ui-react';
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import Form from "../../common/Form";
import TextAreaInput from "../../common/TextAreaInput";
import Fieldset from "../../common/Fieldset";

const InfrastructuurOverzichtForm = (props) => {
    const {
        models,
        onChange,
        onSave,
        onUndo,
        undoButtonDisabled,
        onAdd,
        disabled,
        nieuweInfrastructuren,
        onChangeNieuweInfrastructuren
    } = props;

    const tdStyle = { 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'paddingBottom': '2px', 'paddingTop': '2px', 'paddingLeft': '2px', 'paddingRight': '5px' };

    function returnTdContent(text) {
        return text && text.length > 40 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 40) + "..."}</p>} content={text} /> : text ? text : "";
    }

    const infrastructuurRows = models.map((infrastructuur, i) => {
        const infrastructurenInDomein = models.filter(i => i.domeinId === infrastructuur.domeinId);
        const showFirstColumn = infrastructurenInDomein.findIndex(i => i.id == infrastructuur.id) == 0;
        const infrastructuurDomein = infrastructuur.domeinNaam ? infrastructuur.domeinNaam : <i>{"{Geen sportdomein bekend}"}</i>;
        return (<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '10px' }} key={i}>
            {showFirstColumn ? <td style={tdStyle}><CheckBoxWithChild disabled={disabled} name={"domeinDeelVanSportclub_" + infrastructuur.domeinId} value={infrastructuur.domeinDeelVanSportclub} label={returnTdContent(infrastructuurDomein)} onChange={onChange} /></td> : <td style={tdStyle} />}
            <td style={tdStyle}><CheckBoxWithChild disabled={disabled} name={"deelVanSportclub_" + i} value={infrastructuur.deelVanSportclub} label={returnTdContent(infrastructuur.infrastructuurNaam)} onChange={onChange} /></td>
            <td style={tdStyle}>{returnTdContent(infrastructuur.adres)}</td>
        </tr>);
    });

    return (
        <Section
            title={"Infrastructuren"}
            color={types.COLOR_RED}
        >
            <Form name="infrastructuren"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
                leftButtonLabel="Voeg toe"
                onLeftButtonClick={onAdd}
                leftButtonDisabled={disabled}
                onUndoButtonClick={onUndo}
                undoButtonVisible={!undoButtonDisabled}
            >
                    {models && models.length ?
                        <Section>
                            <p className={"subtitle"}>Selecteer hier enkel de sportinfrastructuren waar trainingen en thuiswedstrijden doorgaan.</p>

                            <Table
                                headers={["Sportdomein", "Sportinfrastructuur", "Adres"]}
                            >
                                {infrastructuurRows}
                            </Table>
                            {nieuweInfrastructuren ?
                                <TextAreaInput style={{ margin: '0px', padding: '0px', width: '100%' }} value={nieuweInfrastructuren} onChange={onChange} name="nieuweInfrastructuren" label="Eigen voorstel sportinfrastructuur" maxLength={400} />
                                :
                                null}
                        </Section>
                        :
                        nieuweInfrastructuren ?
                            <TextAreaInput value={nieuweInfrastructuren} onChange={onChangeNieuweInfrastructuren} name="nieuweInfrastructuren" label="Eigen voorstel sportinfrastructuur" maxLength={400} />
                            :
                            null
                    }
            </Form>
        </Section>
    );
};

InfrastructuurOverzichtForm.propTypes = {
    models: PropTypes.array,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onUndo: PropTypes.func,
    undoButtonDisabled: PropTypes.bool,
    onAdd: PropTypes.func,
    disabled: PropTypes.bool,
    nieuweInfrastructuren: PropTypes.string,
    onChangeNieuweInfrastructuren: PropTypes.func
};

export default InfrastructuurOverzichtForm;